import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage/storage.service';

export const AUTH_GUARD: CanActivateFn = () => {
    const storageService = inject(StorageService);
    const router = inject(Router);

    const loginUser = storageService.getLoginUser();
    if (!loginUser) {
        return router.parseUrl('/logout');
    }

    return true;
};
